import React from 'react';
import classNames from 'classnames';

import { Icon } from '../icon';
import { Spinner } from '../spinner.component';
import { ButtonOwnProps } from './button.model';

export type ButtonBodyProps = ButtonOwnProps & {
  children?: React.ReactNode;
};

export const ButtonBody = ({
  leftIcon,
  rightIcon,
  isPending,
  pendingText,
  variant = 'teal',
  children,
}: ButtonBodyProps) => {
  const showIcon = !isPending || (isPending && !pendingText);

  return (
    <div
      className={classNames(
        'relative flex items-center justify-center pointer-events-none',
        {
          'text-transparent w-6 h-6': isPending && !pendingText,
        }
      )}
    >
      {leftIcon && showIcon ? (
        <div className="mr-2" aria-hidden={true}>
          <Icon icon={leftIcon} />
        </div>
      ) : null}
      {isPending ? (
        <Spinner
          className={classNames({
            'mr-2': pendingText,
            absolute: !pendingText,
            'text-white': ['teal', 'emerald'].includes(variant),
            'text-primary-500': !['teal', 'emerald'].includes(variant),
          })}
        />
      ) : null}
      {isPending && pendingText ? pendingText : children}
      {rightIcon && showIcon ? (
        <div className="ml-2" aria-hidden={true}>
          <Icon icon={rightIcon} />
        </div>
      ) : null}
    </div>
  );
};
